import { ChainId, Token, WETH } from "../../../libs/uniswap";
export const HecoTestAddresses = {
    TOKEN_RING: "0xc8F2eC4c01AD7cDF27431983546da0c35E40237c",
    TOKEN_KTON: "0x9B742ceE92E8A127fcB875c477E79D310ddf2EC3",
    TOKEN_WETH: "0xD4C2F962B8b94cdD2e0B2e8E765d39f32980a1c1",
    ELEMENT_GOLD: "0x46D4e1a0eb97f7C8493644f2D7cDbB548b95Bc83",
    ELEMENT_WOOD: "0x217cA4d5a944636030Bc2fdFF637011f09b29705",
    ELEMENT_WATER: "0x6C495186E6cf9E41d22DF3004c1E3063D988c5D0",
    ELEMENT_FIRE: "0xf787Da51916BcD1da0F5E4723D4102FD6A8a7A69",
    ELEMENT_SOIL: "0x78B89ca151697aB8fA002dF88e0432d292472e55",
    GOLD_RUSH_RAFFLE: "0x229768860d74f6F3A6B7e1576DF86E99e4Fa2140",
    PVETEAM_PROXY: "0x02d95D51B59bDDF0d93AD0acCCB7c7044D3E6561",
    MATERIAL_PROXY: "0x89a206Fa75F42AFb968b43193C086f1970c7155b",
    MATERIALTAKEBACK_PROXY: "0x59D98DaA5316993ED909F9E0572C077f2c407835",
    CRAFTBASE_PROXY: "0x7D53435f78896D273A44d942226DD7947075720d",
    LAND_CLOCK_AUCTION: "0x98C3033041577ddd2510050223d2c918e6a66719",
    APOSTLE_CLOCK_AUCTION: "0xf77fA262f358c38563eF3230C311B6652C92a192",
    SIRING_CLOCK_AUCTION: "0x1C59013AC7dC45B0a9A1428ED618a2a71d73E18e",
    APOSTLE_BASE: "0x517d5344dc5003A36D83684480b15fA268026277",
    LAND_RESOURCE: "0xDf7d26FD7Fdf3EF33F4D357aEF021FCfC2d44737",
    TOKEN_USE: "0xC5eb6110a1C7E04eDD30EC45111aC588f3C6ab20",
    OBJECTOWNERSHIP: "0x8303fa5849d4E7B84A44083BD993733c31f63B3B",
    SETTINGSREGISTRY: "0x7F8c4051f0F0C7324726FF61bb8EAA87902e6c2C",
    POINTS_REWARD_POOL: "0xa502ABf2B637415992d125e53e389199546f99C0",
    TOKEN_USER_POINTS: "0x047A7E5658575dC5DACC6e46434a2360BdDb78B6",
    FURNACE_TREASURE: "0xbdD1d5b058890123905dcea0a5bb5351Ef897e2A",
    FURNACE_ITEM_BASE: "0x96AAcc7e2dFAebD7D1153A0B7C7e4D6a55f7025B",
    FURNACE_TAKEBACK: "0xAb43805C2335055dA0171D06C821cf8A39FFfbcf",
    UNISWAP_EXCHANGE: "0xC2326B74350A66f88620fb91243E3420a2d31EcE",
    STAKINGREWARDSFACTORY: "0xcA713F138149245e915e67C525B19769dce5c1f9",
    GOLDRAFFLEPOOL_PROXY: "0xd2C21514c98BDa0090f5b595463804FE35Ca4C0B",
    WOODRAFFLEPOOL_PROXY: "0x99E37f6711FE193a7e6595B4281046689c671276",
    WATERRAFFLEPOOL_PROXY: "0x6895918B1a8635a9C1792c554a70a9EAD8c0BD38",
    FIRERAFFLEPOOL_PROXY: "0x98C9707B0FcA60F2E6d69054d28cfa08463f1268",
    SOILRAFFLEPOOL_PROXY: "0x0B7b126Cb8365A8887B4b910B7016D2dd379a8c1",
};
export const HecoTestTokens = {
    RING: new Token(ChainId.HECOTESTNET, HecoTestAddresses.TOKEN_RING, 18, "RING", "Darwinia Network Native Token"),
    KTON: new Token(ChainId.HECOTESTNET, HecoTestAddresses.TOKEN_KTON, 18, "KTON", "Darwinia Network Commitment Token"),
    GOLD: new Token(ChainId.HECOTESTNET, HecoTestAddresses.ELEMENT_GOLD, 18, "GOLD", "Evolution Land Token"),
    WOOD: new Token(ChainId.HECOTESTNET, HecoTestAddresses.ELEMENT_WOOD, 18, "WOOD", "Evolution Land Token"),
    WATER: new Token(ChainId.HECOTESTNET, HecoTestAddresses.ELEMENT_WATER, 18, "WATER", "Evolution Land Token"),
    FIRE: new Token(ChainId.HECOTESTNET, HecoTestAddresses.ELEMENT_FIRE, 18, "FIRE", "Evolution Land Token"),
    SOIL: new Token(ChainId.HECOTESTNET, HecoTestAddresses.ELEMENT_SOIL, 18, "SOIL", "Evolution Land Token"),
    WETH: WETH[ChainId.HECOTESTNET],
};
